import React from "react";
import { CircleWithBadge } from "../../../advancing/components/circlewithbadge";

interface Props {
  amountPendingResponses: number
}

const PendingBadge = (props: Props) => {
  const { amountPendingResponses } = props;
  const title = (amountPendingResponses === 1) ? `1 ${RESX.Advancing.itemPendingApproval}` : `${amountPendingResponses} ${RESX.Advancing.itemsPendingApproval}`;
  return <CircleWithBadge icon="layers" count={amountPendingResponses} title={title} />;
};

export default PendingBadge;